import { z } from 'zod';
const text = z.string().min(1).max(1000);
const row = z
  .object({
    rowId: text,
    sourceIdentity: text,
    requestCode: text,
    itemDescription: text,
    quantity: z.string().regex(/^(0|[1-9]\d*)(\.\d+)?$/),
    unit: z.enum(['kg', 'g', 'L', 'mL', 'piece']),
    requestedAt: z.iso.datetime(),
  })
  .strict();
export const oemSourceDocumentSchema = z
  .object({
    artifactId: text,
    version: text,
    sheets: z
      .array(z.object({ name: text, rows: z.array(row).max(1000) }).strict())
      .min(1)
      .max(30),
  })
  .strict();
export const oemImportStageSchema = z
  .object({
    projectId: z.uuid(),
    idempotencyKey: z.uuid(),
    artifactBytes: z.string().max(1000000),
    transformationVersion: z.literal('historical-pr-normalizer-v2'),
    mappings: z
      .array(
        z.object({ sourceIdentity: text, canonicalId: z.uuid().nullable(), reason: text }).strict(),
      )
      .max(3000),
  })
  .strict();
export const oemImportDecisionSchema = z
  .object({ projectId: z.uuid(), batchId: z.uuid(), idempotencyKey: z.uuid(), comment: text })
  .strict();
export const oemImportContracts = {
  document: z.toJSONSchema(oemSourceDocumentSchema),
  stage: z.toJSONSchema(oemImportStageSchema),
  decision: z.toJSONSchema(oemImportDecisionSchema),
};
